export const UPLOAD_DOCUMENTS_FLOW_STEPS = {
  VERIFY_IDENTITY: '1',
  ADD_A_GUARANTOR: '2',
  UPLOAD_GUARANTOR_DOCUMENTS: '3',
  ADD_ANOTHER_GUARANTOR_OR_FINISH: '4',
  WAIT_FOR_CONFIRMATION: '5',
};

export const DOCUMENTS_SIDES = {
  FRONT: 'document_front',
  REAR: 'document_rear',
};

export const USERS_TYPES = {
  ITALIAN_STUDENT: 'italianStudent',
  FOREIGN_STUDENT: 'foreignStudent',
  SELF_EMPLOYED: 'selfEmployed',
  EMPLOYEE: 'employee',
};

export const GUARANTOR_DOCS_DESCRIPTIONS = {
  UNIVERSITY_CERTIFICATION: 'universityCertification',
  BANK_ACCOUNT_BALANCE: 'bankAccountBalance',
  LAST_INCOME_TAX_RETURN: 'lastIncomeTaxReturn',
  SECOND_LAST_INCOME_TAX_RETURN: 'secondLastIncomeTaxReturn',
  WORK_CONTRACT: 'workContract',
  LAST_PAYCHECK: 'lastPaycheck',
  SECOND_LAST_PAYCHECK: 'secondLastPaycheck',
  THIRD_LAST_PAYCHECK: 'thirdLastPaycheck',
};
